import React from 'react'
import {Col, Form, FormGroup, Label, Button, Input} from 'reactstrap'
import Loader from 'react-loader-spinner'
import DownloadIcon from 'react-icons/lib/fa/download'
import DayIcon from 'react-icons/lib/fa/sun-o'
import WeekIcon from 'react-icons/lib/fa/calendar-o'
import MonthIcon from 'react-icons/lib/fa/calendar'
import AllDataIcon from 'react-icons/lib/fa/archive'

const dateToYMD = (date) =>
    `${date.getFullYear()}-${(date.getMonth()+1 > 9 ? date.getMonth()+1 : `0${date.getMonth()+1}`)}-${(date.getDay() > 9 ? date.getDate() : `0${date.getDate()}`)}`

let handleQuickButtonClick = (buttonName, startDateHandler, endDateHandler, submit) => (e) => {
    e.preventDefault()
    let today = new Date()
    if (buttonName === 'day') {
        startDateHandler(today)
        endDateHandler(today)
        submit(e)
    } else if (buttonName === 'week') {
        let weekAgo = new Date()
        weekAgo.setDate(today.getDate() - 7)
        startDateHandler(weekAgo)
        endDateHandler(today)
        submit(e)
    } else if (buttonName === 'month') {
        let monthAgo = new Date()
        monthAgo.setMonth(today.getMonth() - 1)
        startDateHandler(monthAgo)
        endDateHandler(today)
        submit(e)
    } else if (buttonName === 'all') {
        let tenYearsAgo = new Date()
        tenYearsAgo.setFullYear(today.getFullYear() - 10)
        startDateHandler(tenYearsAgo)
        endDateHandler(today)

        submit(e)
    }
}

let ControllerLogsForm = ({onStartDateChange, onEndDateChange, onSubmit, loading, defaultStart, defaultEnd}) =>
    <Col xs={10} sm={8} md={6} lg={4} className="offset-1 offset-sm-2 offset-md-3 offset-lg-4">
        <Form className="mt-2 mb-5" onSubmit={onSubmit}>
            <FormGroup className="mt-5">
                <Label for="startDate">Start Date</Label>
                <Input type="date" name="startDate" defaultValue={dateToYMD(defaultStart)} onChange={(evt) => onStartDateChange(evt.target.valueAsDate)}/>
            </FormGroup>
            <FormGroup className="mb-5">
                <Label for="endDate">End Date</Label>
                <Input type="date" name="endDate" defaultValue={dateToYMD(defaultEnd)} onChange={(evt) => onEndDateChange(evt.target.valueAsDate)}/>
            </FormGroup>
            { loading ?
                <div className="mt-5 mb-5 col-12 text-center">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </div>:
                    <FormGroup className="mb-5">
                        <Button className="col-12 mb-3">
                            <DownloadIcon className="mr-2"/>
                            Download Log File
                        </Button>
                        <Col xs={12} sm={6} className="d-block d-sm-inline-block">
                            <Button className="col-12 mb-2"
                                     onClick={handleQuickButtonClick('day', onStartDateChange, onEndDateChange, onSubmit)}>
                                <DayIcon className="mr-2"/>
                                Past Day
                            </Button>
                            <Button className="col-12 mb-2"
                                     onClick={handleQuickButtonClick('week', onStartDateChange, onEndDateChange, onSubmit)}>
                                <WeekIcon className="mr-2"/>
                                Past Week
                            </Button>
                        </Col>
                        <Col xs={12} sm={6} className="d-block d-sm-inline-block">
                            <Button className="col-12 mb-2"
                                     onClick={handleQuickButtonClick('month', onStartDateChange, onEndDateChange, onSubmit)}>
                                <MonthIcon className="mr-2"/>
                                Past Month
                            </Button>
                            <Button className="col-12 mb-2"
                                     onClick={handleQuickButtonClick('all', onStartDateChange, onEndDateChange, onSubmit)}>
                                <AllDataIcon className="mr-2"/>
                                All Data
                            </Button>
                        </Col>
                    </FormGroup>}
        </Form>
    </Col>

export default ControllerLogsForm



// WEBPACK FOOTER //
// ./src/components/ui/ControllerLogsForm.js